{
	"required": "Campo obligatorio",
	"passwordMustBeSame": "Las contraseñas deben ser iguales",
	"minLength": "La contraseña debe tener al menos {{count}} caracteres",
	"passwordUppercase": "La contraseña debe tener al menos una letra mayúscula",
	"passwordLowercase": "La contraseña debe tener al menos una letra minúscula",
	"passwordNumber": "La contraseña debe tener al menos un número",
	"passwordSpecial": "La contraseña debe tener al menos un carácter especial"
}
